import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import ReactModal from 'react-modal';

class DeleteProgress extends Component {
    render() {
        return (
            <span className="iadel-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Deleting ...
            </span>
        );
    }
}

class InterestAreasDeleteDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);

        this.state = {
            modalOpen: false,
            error: null,
            deleting: false,
            name: null,
            docTitle: null
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_InterestAreasDeleteDialog');
    }

    componentWillUnmount() {
    }

    close() {
        this.setState({
            modalOpen: false,
            deleting: false,
            error: null,
            name: null,
            docTitle: null
        });
    };

    open(name, docTitle=null) {
        this.setState({
            modalOpen: true,
            deleting: false,
            error: null,
            name,
            docTitle
        });
    };

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            deleting: true
        }, ()=> {
            if (this.state.docTitle) {
                urlHandler.deleteInterestAreaDocument(this.state.name, this.state.docTitle, (result, status) => {
                    if (status === 204) {
                        this.setState({
                            error: null,
                            deleting: false,
                            modalOpen: false
                        }, () => {
                            if (this.props.onDelete) {
                                this.props.onDelete(this.state.name, this.state.docTitle);
                            }
                        });
                    } else {
                        this.setState({
                            error: decodeURIComponent(result.error_message),
                            deleting: false,
                        });
                    }
                })
            } else {
                urlHandler.deleteInterestArea(this.state.name, (result, status) => {
                    if (status === 204) {
                        this.setState({
                            error: null,
                            deleting: false,
                            modalOpen: false
                        }, () => {
                            if (this.props.onDelete) {
                                this.props.onDelete(this.state.name, null);
                            }
                        });
                    } else {
                        this.setState({
                            error: decodeURIComponent(result.error_message),
                            deleting: false,
                        });
                    }
                })
            }
        });
    }

    onReset() {
        this.close();
    }

    render() {
        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '600px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <span id="rm_InterestAreasDeleteDialog">
                <ReactModal isOpen={this.state.modalOpen}
                    onRequestClose={this.close} 
                    style={styles}
                    contentLabel="deleteIA"
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="iadel">
                        <div className="iadel-header">
                            {this.state.docTitle ?
                            <span className="header-text">Delete Document</span>
                            :
                            <span className="header-text">Delete Interest Area</span>
                            }
                        </div> 
                        <div className="iadel-content" style={{maxHeight: '300px'}}>
                            {this.state.docTitle ?
                                <div>Are you sure you want to delete the following document?<br/>
                                    <br/>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><b>Document:&nbsp;&nbsp;</b></td>
                                                <td>{this.state.docTitle}</td>
                                            </tr>
                                            <tr>
                                                <td><b>From:</b></td>
                                                <td>{this.state.name}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            :
                                <div>Are you sure you want to delete the following interest area?<br/>
                                    <br/>
                                    <b>{this.state.name}</b><br/>
                                </div>
                            }
                            <br/>
                            <span className="iadel-delete-note">NOTE: This action cannot be undone.</span>
                        </div>
                        
                        <div className="iadel-footer">
                            {this.state.deleting ? <DeleteProgress /> : null}
                            {this.state.error ? <span className="iadel-delete-error">{this.state.error}</span> : null}
                            <button type="button" className="iadel-default-button" onClick={this.onSubmit}>Delete</button>
                            <button type="button" className="iadel-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </span>
        );
    };
}

InterestAreasDeleteDialog.propTypes = {
    onDelete: PropTypes.func
};

export default InterestAreasDeleteDialog;


